import { CLink } from '@/CLink';
import { TxtBtn } from '@/buttons';
import { flexStart, ml, mr, npx, px, py } from '@/layout/styles/classes';
import { ReactComponent as AllergiesIcon } from '@a/images/home/collections/allergies.svg';
import { ReactComponent as AnxietyIcon } from '@a/images/home/collections/anxiety.svg';
import { ReactComponent as ArthritisIcon } from '@a/images/home/collections/arthritis.svg';
import { ReactComponent as BrainIcon } from '@a/images/home/collections/brain.svg';
import { ReactComponent as CancerIcon } from '@a/images/home/collections/cancer.svg';
import { ReactComponent as Vectors } from '@a/images/home/collections/vector.svg';

import styled from '@emotion/styled';

const Section = styled.section`
    ${py};
    ${px};
    margin: 0 auto;
    max-width: 1440px;
`;

const Box = styled.div<{ desktop?: boolean }>`
    max-width: 546px;
    display: ${({ desktop }) => (desktop ? 'none' : 'block')};

    > p {
        :first-of-type {
            margin: 0;
        }

        :last-of-type {
            color: ${({ theme }) => theme.colors.gray3};
            margin: 0;
            font-size: 1rem;
        }
    }

    > h2 {
        margin: 12px 0 24px;
        color: ${({ theme }) => theme.colors.blue7};
    }

    @media (min-width: 1280px) {
        display: ${({ desktop }) => (desktop ? 'block' : 'none')};
        margin-right: 48px;

        > h2 {
            margin: 12px 0 17px;
        }
    }
`;

const Cards = styled.div`
    ${npx};
    display: flex;
    overflow-x: auto;
    margin-top: 24px;
    gap: 16px;

    > div:nth-of-type(2) {
        ${ml};
    }

    > svg:last-of-type {
        ${mr};
        flex-shrink: 0;
    }

    @media (min-width: 1280px) {
        margin: 0 !important;
        overflow: unset;
        flex-wrap: wrap;

        > div:nth-of-type(2) {
            margin-left: 0 !important;
        }

        > svg:last-of-type {
            margin-right: 0 !important;
        }
    }
`;

export const CollectionCard = styled.div`
    ${flexStart};
    flex-direction: column;
    width: 343px;
    height: 189px;
    flex-shrink: 0;
    padding: 16px 32px;
    border-radius: 16px;
    background-color: ${({ theme }) => theme.colors.blue2};
    position: relative;
    transition: box-shadow 0.3s ease-in-out;

    :hover {
        box-shadow: 0px 16px 48px -24px #205d72;
    }

    > p {
        color: ${({ theme }) => theme.colors.blue7};
        font-weight: 600;
        font-size: 1.625rem;
        line-height: 138%;
        margin: 0;
        text-transform: capitalize;
    }

    > a {
        margin-top: auto;

        > svg {
            transform: translateY(-1.5px);
        }
    }

    > .gatsby-image-wrapper,
    > svg {
        position: absolute;
        right: 32px;
        bottom: 32px;
    }
`;

const SeeAll = styled(TxtBtn)`
    max-width: max-content;
    margin: 24px auto 0;
    display: block;

    > svg {
        display: none;
    }
`;

export const SeeAllCollections = ({ className }: { className?: string }) => (
    <SeeAll className={className} as={CLink} to="/collections/">
        see all collections
    </SeeAll>
);

export const Collections = () => {
    return (
        <Section>
            <Box>
                <p className="tagline">Feel and See the Difference</p>
                <h2>Be Better, Be the Best</h2>
                <p>
                    There are so many conditions that can be treated with proper supplementation of
                    minerals. Learn which products would it take to alleviate some of these symptoms
                    and fast track your health to be better and beyond.
                </p>
            </Box>
            <Cards>
                <Box desktop>
                    <p className="tagline">Feel and See the Difference</p>
                    <h2>Be Better, Be the Best</h2>
                    <p>
                        There are so many conditions that can be treated with proper supplementation
                        of minerals. Learn which products would it take to alleviate some of these
                        symptoms and fast track your health to be better and beyond.
                    </p>
                </Box>
                <CollectionCard>
                    <p>Allergies</p>
                    <TxtBtn as={CLink} to="/collections/allergies/">
                        see more
                    </TxtBtn>
                    <AllergiesIcon />
                </CollectionCard>
                <CollectionCard>
                    <p>Anxiety</p>
                    <TxtBtn as={CLink} to="/collections/anxiety/">
                        see more
                    </TxtBtn>
                    <AnxietyIcon />
                </CollectionCard>
                <CollectionCard>
                    <p>Arthritis</p>
                    <TxtBtn as={CLink} to="/collections/Arthritis/">
                        see more
                    </TxtBtn>
                    <ArthritisIcon />
                </CollectionCard>
                <CollectionCard>
                    <p>Brain & Nerves</p>
                    <TxtBtn as={CLink} to="/collections/brain-nerves/">
                        see more
                    </TxtBtn>
                    <BrainIcon />
                </CollectionCard>
                <CollectionCard>
                    <p>Cancer</p>
                    <TxtBtn as={CLink} to="/collections/cancer/">
                        see more
                    </TxtBtn>
                    <CancerIcon />
                </CollectionCard>
                <Vectors />
            </Cards>
            <SeeAllCollections />
        </Section>
    );
};
